import {
    GET_EMPLOYEE_REQUEST,
    GET_EMPLOYEE_SUCCESS,
    GET_EMPLOYEE_FAILURE,
    SET_EMPLOYEE_REQUEST,
    SET_EMPLOYEE_SUCCESS,
    SET_EMPLOYEE_FAILURE,
    CREATE_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_SUCCESS,
    CREATE_EMPLOYEE_FAILURE,
    UPDATE_EMPLOYEE_REQUEST,
    UPDATE_EMPLOYEE_SUCCESS,
    UPDATE_EMPLOYEE_FAILURE,
    ADD_EMPLOYEE_FILES_REQUEST,
    ADD_EMPLOYEE_FILES_SUCCESS,
    ADD_EMPLOYEE_FILES_FAILURE,
    REMOVE_EMPLOYEE_FILE_REQUEST,
    REMOVE_EMPLOYEE_FILE_SUCCESS,
    REMOVE_EMPLOYEE_FILE_FAILURE
} from '../constants/employeeActionTypes';

const initialState = {
    employees: [],
    employee: {},
    loading: {
        getEmployee: false,
        setEmployee: false,
        createEmployee: false,
        updateEmployee: false,
        addEmployeeFiles: false,
        removeEmployeeFile: false,
    },
    error: null
}

const employeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getEmployee: true },
                error: null
            };
        case GET_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employee: action.payload,
                loading: { ...state.loading, getEmployee: false }
            };
        case GET_EMPLOYEE_FAILURE:
            return { ...state,
                loading: { ...state.loading, getEmployee: false },
                error: action.payload
            };
        case SET_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, setEmployee: true },
                error: null
            };
        case SET_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employee: action.payload,
                loading: { ...state.loading, setEmployee: false }
            };
        case SET_EMPLOYEE_FAILURE:
            return { ...state,
                loading: { ...state.loading, setEmployee: false },
                error: action.payload
            };
        case CREATE_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, createEmployee: true },
                error: null
            };
        case CREATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employee: action.payload.employee,
                loading: { ...state.loading, createEmployee: false }
            };
        case CREATE_EMPLOYEE_FAILURE:
            return { ...state,
                loading: { ...state.loading, createEmployee: false },
                error: action.payload
            };
        case UPDATE_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updateEmployee: true },
                error: null
            };
        case UPDATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employee: action.payload,
                loading: { ...state.loading, updateEmployee: false }
            };
        case UPDATE_EMPLOYEE_FAILURE:
            return { ...state,
                loading: { ...state.loading, updateEmployee: false },
                error: action.payload
            };
        case ADD_EMPLOYEE_FILES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, addEmployeeFiles: true },
                error: null
            };
        case ADD_EMPLOYEE_FILES_SUCCESS:
            const existingFiles = state.employee.EmployeeFiles || [];
            const newFiles = action.payload.EmployeeFiles || [];
            return {
                ...state,
                employee: {
                    ...state.employee,
                    EmployeeFiles: [...existingFiles, ...newFiles]
                }
            };
        case ADD_EMPLOYEE_FILES_FAILURE:
            return { ...state,
                loading: { ...state.loading, addEmployeeFiles: false },
                error: action.payload
            };
        case REMOVE_EMPLOYEE_FILE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, removeEmployeeFile: true },
                error: null
            };
        case REMOVE_EMPLOYEE_FILE_SUCCESS:
            return {
                ...state,
                employee: {
                    ...state.employee,
                    EmployeeFiles: state.employee.EmployeeFiles.filter(file => file.ID !== action.payload.ID)
                }
            };
        case REMOVE_EMPLOYEE_FILE_FAILURE:
            return { ...state,
                loading: { ...state.loading, removeEmployeeFile: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default employeeReducer;